export default __webpack_public_path__ + "static/media/m_diagram2.c81665d0.png";